module.exports = __webpack_public_path__ + "static/janusz-bryzek-0684629fbb3a1daa8b09ecce21aef7cb.png";